export function blurRoot() {
  document.getElementById('root').style.filter = 'blur(2px)';
}

export function clearBlurRoot() {
  document.getElementById('root').style.filter = '';
}
